"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GIT_COMMIT = exports.GIT_BRANCH = exports.PACKAGE_VERSION = exports.PACKAGE_NAME = exports.BUILD_DATE = void 0;
// This file is auto-generated by the build system.
exports.BUILD_DATE = "Fri, 09 Jun 2023 16:40:31 GMT";
exports.PACKAGE_NAME = "html-living-framework";
exports.PACKAGE_VERSION = "1.0.0-rc1";
exports.GIT_BRANCH = "HEAD";
exports.GIT_COMMIT = "0835b8cc1e0ba135c499c24c23bc6169f0485cbf";
